import React from "react";

interface ButtonLoadingOnBusyProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  busy: boolean;
}

const ButtonLoadingOnBusy: React.FC<ButtonLoadingOnBusyProps> = ({
  busy,
  children,
  ...props
}) => {
  const buttonContent = busy ? (
    <>
      <div className="invisible">{children}</div>
      <span className="absolute m-auto loading loading-spinner "></span>
    </>
  ) : (
    children
  );
  return (
    <button
      disabled={busy || props.disabled}
      {...props}
      className={
        (props.className || "") + (busy ? " relative cursor-default" : "")
      }
    >
      {buttonContent}
    </button>
  );
};

export default ButtonLoadingOnBusy;
